import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconsModule, LinkModule, LoaderModule } from '@fcom/ui-components';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { DirectiveModule } from '@fcom/common/directives/directive.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';

import { OndMarketingOffersListComponent } from './components/ond-marketing-offers-list/ond-marketing-offers-list.component';
import { OndMarketingOffersComponent } from './components/ond-marketing-offers/ond-marketing-offers.component';
import { OndMarketingCrossLinkingComponent } from './components/ond-marketing-cross-linking/ond-marketing-cross-linking.component';
import { OndMarketingDisambiguationLinksComponent } from './components/ond-marketing-disambiguation-links/ond-marketing-disambiguation-links.component';
import { OndMarketingLinkListComponent } from './components/ond-marketing-link-list/ond-marketing-link-list.component';

@NgModule({
  imports: [
    CommonModule,
    DirectiveModule,
    PipesModule,
    ComponentsModule,
    UiTranslateModule,
    IconsModule,
    LinkModule,
    LoaderModule,
  ],
  declarations: [
    OndMarketingOffersListComponent,
    OndMarketingOffersComponent,
    OndMarketingCrossLinkingComponent,
    OndMarketingDisambiguationLinksComponent,
    OndMarketingLinkListComponent,
  ],
  exports: [
    OndMarketingOffersListComponent,
    OndMarketingOffersComponent,
    OndMarketingCrossLinkingComponent,
    OndMarketingDisambiguationLinksComponent,
    OndMarketingLinkListComponent,
  ],
})
export class OndMarketingLandingCoreModule {}
